export default __webpack_public_path__ + "static/media/icons8-secure-mail-48.74229c90.svg";